const exportedObject = {
  getPrecertificacionData: {},
  getPrecertificacionLoading: false,
  getPrecertificacionError: null,

  confirmarPrecertificacionData: {},
  confirmarPrecertificacionLoading: false,
  confirmarPrecertificacionError: null,

  cancelarPrecertificacionData: {},
  cancelarPrecertificacionLoading: false,
  cancelarPrecertificacionError: null,

  getAutorizacionMadreData: {},
  getAutorizacionMadreDataLoading: false,
  getAutorizacionMadreDataError: null,
};

export default exportedObject;